export const selectReducer = (state) => state.myDocumentManagement;

export const selectMyDocument = (state) =>
  selectReducer(state) ? selectReducer(state).get('myDocument') : undefined;
